// src/pages/exercise/components/index.jsx
import { Canvas, useThree } from "@react-three/fiber";
import { Suspense, useRef, useEffect } from "react";
import { useStore } from "./Stores/exerciseStore";
import { CharacterManager } from "./Character/CharacterManager";
import { TransitionController } from "./Character/TransitionController";
import { SelectionUI } from "./UI/SelectionUI";
import { ExerciseSuggestionPanel } from "./UI/ExerciseSuggestionPanel"; // ← ADD
import SceneModel from "./Scene/Model";
import Lighting from "./Scene/Lighting";

const CAMERA_TARGET = [0, 0, 0.7];

function CameraController({ target }) {
  const { camera } = useThree();
  useEffect(() => {
    camera.lookAt(target[0], target[1], target[2]);
  }, [camera, target]);
  return null;
}

function Scene3D() {
  const { phase, triggerTransition1, triggerTransition2 } = useStore();
  const charGroupRef = useRef();

  const onWheel = (e) => {
    if (e.deltaY <= 30) return;

    if (phase === "SELECTION") {
      triggerTransition1();
    } else if (phase === "EXERCISE") {
      triggerTransition2();
    }
  };

  return (
    <div
      style={{ width: "100vw", height: "100vh", position: "fixed" }}
      onWheel={onWheel}
    >
      <Canvas camera={{ position: [0, -1.5, 0.8], fov: 75 }}>
        <CameraController target={CAMERA_TARGET} />
        <Suspense fallback={null}>
          <Lighting />
          <SceneModel />
          <CharacterManager groupRef={charGroupRef} />
          <TransitionController charGroupRef={charGroupRef} />
        </Suspense>
      </Canvas>

      <SelectionUI />
      <ExerciseSuggestionPanel />
    </div>
  );
}

export default Scene3D;